export default __webpack_public_path__ + "static/media/icon-troisPoints.8646bcd4.svg";